import { useState, useEffect, useRef } from "react";
import { api } from "./api";

const fmtTime = iso => new Date(iso).toLocaleString("tr-TR", { day:"2-digit", month:"2-digit", hour:"2-digit", minute:"2-digit" });

export default function Chat({ currentUser, onClose }) {
  const isAdmin = currentUser.role === "admin";
  const [messages,   setMessages]   = useState([]);
  const [text,       setText]       = useState("");
  const [confirming, setConfirming] = useState(false);
  const bottomRef = useRef(null);

  async function loadMessages() {
    try {
      const rows = await api.getGroupMessages();
      setMessages(rows);
      await api.markGroupRead();
    } catch {}
  }

  useEffect(() => {
    loadMessages();
    const iv = setInterval(loadMessages, 4000);
    return () => clearInterval(iv);
  }, []);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  async function send() {
    const msg = text.trim();
    if (!msg) return;
    try {
      await api.sendMessage({ message: msg, receiver: null });
      setText("");
      loadMessages();
    } catch {}
  }

  async function clearAll() {
    try {
      await api.clearGroupMessages();
      setMessages([]);
    } catch(e) { alert('Hata: ' + e.message); }
  }

  const inp = { flex:1, padding:"10px 14px", background:"rgba(255,255,255,.07)", border:"1px solid rgba(255,255,255,.15)", borderRadius:10, color:"#fff", fontSize:14, outline:"none", resize:"none" };

  return (
    <div style={{ position:"fixed", inset:0, zIndex:99999, background:"rgba(0,0,0,.7)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"Georgia,serif" }}>
      <div style={{ background:"linear-gradient(135deg,#0a0814,#1c1535)", border:"1px solid rgba(255,255,255,.12)", borderRadius:20, width:500, maxWidth:"95vw", height:560, maxHeight:"90vh", display:"flex", flexDirection:"column", boxShadow:"0 30px 80px rgba(0,0,0,.7)" }}>

        <div style={{ padding:"16px 20px", borderBottom:"1px solid rgba(255,255,255,.08)", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <span style={{ fontSize:20 }}>💬</span>
            <span style={{ color:"#fff", fontWeight:700, fontSize:16 }}>Genel Chat</span>
          </div>
          <div style={{ display:"flex", gap:8 }}>
            {isAdmin && (
              <button onClick={clearAll} style={{ background:confirming?"rgba(255,107,107,.3)":"rgba(255,107,107,.1)", border:"1px solid rgba(255,107,107,.3)", borderRadius:8, color:"#ff6b6b", cursor:"pointer", padding:"5px 12px", fontSize:13 }}>
                {confirming ? "Emin misiniz?" : "🗑️ Temizle"}
              </button>
            )}
            <button onClick={onClose} style={{ background:"rgba(255,255,255,.07)", border:"1px solid rgba(255,255,255,.15)", borderRadius:8, color:"rgba(255,255,255,.6)", cursor:"pointer", padding:"5px 12px", fontSize:13 }}>✕ Kapat</button>
          </div>
        </div>

        <div style={{ flex:1, overflowY:"auto", padding:"14px 16px", display:"flex", flexDirection:"column", gap:10 }}>
          {messages.length === 0 && (
            <div style={{ color:"rgba(255,255,255,.2)", textAlign:"center", marginTop:40, fontSize:13 }}>Henüz mesaj yok</div>
          )}
          {messages.map(m => {
            const isMe = m.sender === currentUser.username;
            return (
              <div key={m.id} style={{ display:"flex", flexDirection:"column", alignItems:isMe?"flex-end":"flex-start" }}>
                <div style={{ maxWidth:"75%", background:isMe?"linear-gradient(135deg,#667eea,#764ba2)":"rgba(255,255,255,.08)", borderRadius:isMe?"16px 16px 4px 16px":"16px 16px 16px 4px", padding:"10px 14px" }}>
                  {!isMe && <div style={{ color:"rgba(255,255,255,.6)", fontSize:11, marginBottom:4, fontWeight:700 }}>{m.sender_name}</div>}
                  <div style={{ color:"#fff", fontSize:14, lineHeight:1.5, wordBreak:"break-word" }}>{m.message}</div>
                </div>
                <div style={{ color:"rgba(255,255,255,.2)", fontSize:10, marginTop:2 }}>{fmtTime(m.created_at)}</div>
              </div>
            );
          })}
          <div ref={bottomRef} />
        </div>

        <div style={{ padding:"12px 16px", borderTop:"1px solid rgba(255,255,255,.07)", display:"flex", gap:10 }}>
          <textarea value={text} onChange={e=>setText(e.target.value)} onKeyDown={e=>{ if(e.key==="Enter"&&!e.shiftKey){ e.preventDefault(); send(); } }} placeholder="Mesaj yaz… (Enter gönder)" rows={2} style={inp} />
          <button onClick={send} disabled={!text.trim()} style={{ padding:"0 18px", background:text.trim()?"linear-gradient(135deg,#667eea,#764ba2)":"rgba(255,255,255,.05)", border:"1px solid rgba(255,255,255,.1)", borderRadius:10, color:text.trim()?"#fff":"rgba(255,255,255,.2)", fontWeight:700, cursor:text.trim()?"pointer":"not-allowed", fontSize:13, whiteSpace:"nowrap" }}>Gönder</button>
        </div>
      </div>
    </div>
  );
}
